import React, {FC} from 'react';

import {InboxesVisualConversationSelection} from '../../../store/panels/cells/helpers/cellsPanelSelectionHelpers';
import {CellsPanelId, ViewerPanelId} from '../../../store/panels/panelStateBase';
import {ViewerPanelPageState} from '../../../store/panels/viewer/viewerPanelState';
import {ViewerContainer} from '../../inboxes/viewer/viewerContainer';
import {VisitorConversationsHeaderContainer} from './visitorConversationsHeaderContainer';

/*
 * Props.
 */

interface VisitorConversationsViewerProps {
  cellsPanelId: CellsPanelId;
  panelId: ViewerPanelId;
  topbarPage: ViewerPanelPageState;
  topbarConversationSelection: InboxesVisualConversationSelection;
  contentPage: ViewerPanelPageState;
  hasVisitorExperienceV3: boolean;
}

/*
 * Component.
 */

export const VisitorConversationsViewer: FC<VisitorConversationsViewerProps> = (props) => (
  <ViewerContainer
    cellsPanelId={props.cellsPanelId}
    panelId={props.panelId}
    header={
      <VisitorConversationsHeaderContainer
        panelId={props.panelId}
        cellsContext={props.topbarPage.cellsContext}
        inboxesParameters={props.topbarPage.parameters}
        conversationSelection={props.topbarConversationSelection}
        hasVisitorExperienceV3={props.hasVisitorExperienceV3}
      />
    }
    contentPage={props.contentPage}
  />
);
